import React from "react";
import { Chip, Link, Typography } from "@mui/material";

import type { ColumnInterface } from "../../common/table/Table";
import { formatMoment } from "../crm/contactDetail/contactDetail";
import { attachmentLabel } from "../userDetails/userDetailsModel";

const noSort = { skipSorting: true };

/** Which way a message went and what it said, on a person's page and on the list of everybody's. */
export const whatsAppDirectionColumn: ColumnInterface = {
  ...noSort,
  label: "",
  key: "direction",
  minWidth: "100px",
  rowRender: (row) =>
    row.direction === "INBOUND" ? (
      <Chip size="small" color="primary" label="Received" />
    ) : (
      <Chip size="small" variant="outlined" label="Sent" />
    ),
};

export const whatsAppDetailColumns: ColumnInterface[] = [
  {
    ...noSort,
    label: "Message",
    key: "message",
    minWidth: "320px",
    rowRender: (row) => (
      <>
        {row.message && (
          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {row.message}
          </Typography>
        )}
        {row.media.map((item: { url: string; contentType?: string | null }) => (
          <Link
            key={item.url}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            variant="body2"
            sx={{ display: "block" }}
          >
            {attachmentLabel(item.contentType)}
          </Link>
        ))}
      </>
    ),
  },
  { ...noSort, label: "Details", key: "note", minWidth: "160px", rowRender: (row) => row.note ?? "" },
  { ...noSort, label: "Number", key: "phone", minWidth: "140px" },
  { ...noSort, label: "When", key: "createdAt", minWidth: "170px", rowRender: (row) => formatMoment(row.createdAt) },
];
